import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation, Trans } from 'react-i18next';
import useUsersApi from 'on_web/hooks/useUsersApi';
import useInterval from 'on_web/hooks/useInterval';

import { Grid, Box, Typography } from '@material-ui/core';

import Header from 'on_web/components/shared/Menu/Header/Header';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import Button from 'on_web/components/shared/Common/Button';
import NotificationPopper from 'on_web/components/shared/Popper/NotificationPopper';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import RiskAssessmentCard from 'on_web/components/shared/RiskAssessmentCard/RiskAssessmentCard';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';
import RiskReportCard from 'on_web/components/shared/RiskReportCard/RiskReportCard';
import RiskRecommendationCard from 'on_web/components/shared/RiskRecommendationCard/RiskRecommendationCard';
import AssessmentSectionTitle from 'on_web/components/shared/AssessmentSectionTitle/AssessmentSectionTitle';
import ScheduleEnterpriseDemoBanner from 'on_web/components/shared/ScheduleEnterpriseDemoBanner/ScheduleEnterpriseDemoBanner';
import LikelihoodReportCard from 'on_web/components/shared/LikelihoodReportCard/LikelihoodReportCard';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CloseIcon from '@material-ui/icons/Close';

import {
  parseDnaTotalRisk,
  getHealthRiskScore,
  getHealthRiskScorePercentage,
  parseLikelihood,
  parseHealthRisks,
  userCanSeeDnaContent,
  isImputationCompleted,
  isImputationInError,
  isImputationInProgress,
  isDnaUploaded,
  getUnknownDnaRisk,
  isGenotypeInvalid,
} from 'on_web/helpers/risksHelper';

import { PDFReportIcon } from 'on_web/assets/iconsList';

import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';
import {
  ROUTE_ASSESSMENT_HEALTH_RISKS,
  ROUTE_ASSESSMENT_DNA_RISKS,
  ROUTE_ONBOARDING_DNA,
} from 'routes';

import { mapRoutesToMenuItems } from 'on_web/helpers/menuItems';
import ErrorMessageTile from 'on_web/components/shared/ErrorMessageTile/ErrorMessageTile';
import CustomDialog from 'on_web/components/shared/CustomDialog/CustomDialog';

import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { dnaBasedProcessing } from 'on_web/assets/imageList';

export default function ReportsMyAssessment(props) {
  const [
    {
      response,
      errorSpareAssessments,
      getSpareAssessments,
      getUserData,
      getGenotype,
      getReports,
      partialUpdateUserData,
      responseReports,
      saveReports,
      getProfile,
    },
  ] = useUsersApi();
  const { t } = useTranslation();
  const [likelihoodObj, setLikelihoodObj] = useState(null);
  const [responseLikelihood, setResponseLikelihood] = useState(null);
  const [genotypeData, setGenotypeData] = useState(null);
  const [responseHealthBasedRisks, setResponseHealthBasedRisks] = useState(
    null
  );
  const [healthBasedRisksObj, setHealthBasedRisksObj] = useState(null);
  const [responseDnaBasedRisks, setResponseDnaBasedRisks] = useState(null);
  const [responseBloodType, setResponseBloodType] = useState(null);

  const [dnaTotalRisk, setDnaTotalRisk] = useState(getUnknownDnaRisk(t));
  const [userGroups, setUserGroups] = useState(undefined);
  const [openDialog, setOpenDialog] = useState(undefined);
  const [processingErrorSeen, setProcessingErrorSeen] = useState(false);

  const [popperAnchor, setPopperAnchor] = useState(null);
  const [notificationSeen, setNotificationSeen] = useState(null);
  const [genotypeCheckInterval, setGenotypeCheckInterval] = useState(null);

  const [isDesktop] = useCheckScreenSize();

  const useStyles = makeStyles(theme => ({
    title: {
      fontFamily: 'Museo-500',
      fontSize: 18,
      lineHeight: 1.19,
      color: '#2a343f',
      textTransform: 'uppercase',
      paddingTop: '20px',
      textAlign: 'center',
      paddingLeft: '20px',
    },
    description: {
      marginTop: '19px',
      paddingLeft: '20px',
      paddingRight: '20px',
      fontFamily: 'MuseoSans',
      fontWeight: 300,
      fontSize: '16px',
    },
    diffAssesmentButton: {
      color: '#2a343f',
      fontFamily: 'MuseoSans',
      fontWeight: 300,
      fontStyle: 'italic',
      fontSize: 10,
      backgroundColor: '#ffffff',
      '&:hover': {
        backgroundColor: '#ffffff',
      },
    },
    iconButton: {
      color: '#33B0CE',
      display: 'flex',
      justifyContent: 'flex-end',
      // padding: '19px',
    },
    closeIcon: {
      width: '40px',
      height: '40px',
    },
    dialogBody: {
      paddingTop: '6px',
      paddingBottom: '54px',
      display: 'flex',
      flexDirection: 'column',
    },
    dialogText: {
      fontSize: '15px',
      fontFamily: 'Museo',
      fontWeight: '500',
      color: '#222222',
      textAlign: 'left',
    },
  }));
  const classes = useStyles();

  useInterval(() => {
    if (responseReports == null || responseReports.download_url == null) {
      getReports();
    }
  }, 5000);

  const createGenotypeData = genotypeResponse => {
    if (
      genotypeResponse == null ||
      Object.keys(genotypeResponse).length === 0
    ) {
      return null;
    }

    return {
      genotype_status: genotypeResponse.status,
      imputed_genotype_status: genotypeResponse.imputed_genotype
        ? genotypeResponse.imputed_genotype.status
        : null,
    };
  };

  useEffect(() => {
    let userResponse = null;
    getUserData()
      .then(response => {
        userResponse = response;
        if (response != null) {
          if (response.groups != null) {
            setUserGroups(response.groups);
          }

          if (
            response.user_metadata != null &&
            response.user_metadata.processingErrorSeen != null
          ) {
            setProcessingErrorSeen(response.user_metadata.processingErrorSeen);
          }
        }
      })
      .then(() => {
        return getGenotype();
      })
      .then(response => {
        if (response == null || Object.keys(response).length === 0) {
          return;
        }

        const genotypeStatus = createGenotypeData(response);
        setGenotypeData(genotypeStatus);

        if (
          isImputationInError(genotypeStatus) ||
          isImputationCompleted(genotypeStatus)
        ) {
          if (userResponse != null) {
            if (
              userResponse.user_metadata != null &&
              userResponse.user_metadata.dnaNotificationSeen !== null
            ) {
              const notification =
                userResponse.user_metadata.dnaNotificationSeen;
              partialUpdateUserData({
                user_metadata: { dnaNotificationSeen: notification },
              }).then(() => setNotificationSeen(notification));
            } else {
              partialUpdateUserData({
                user_metadata: { dnaNotificationSeen: null },
              }).then(() => setNotificationSeen(null));
            }
          }
        } else {
          setGenotypeCheckInterval(10000);
        }
      });
  }, [getGenotype, getUserData, partialUpdateUserData]);

  useInterval(() => {
    if (genotypeCheckInterval != null && genotypeCheckInterval > 0) {
      getGenotype()
        .then(response => {
          if (response !== null && response.status !== null) {
            if (
              isImputationInError(createGenotypeData(response)) ||
              isImputationCompleted(createGenotypeData(response))
            ) {
              partialUpdateUserData({
                user_metadata: { dnaNotificationSeen: false },
              }).then(() => setNotificationSeen(false));
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, genotypeCheckInterval);

  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.healthBasedRisks &&
      props.location.state.infectionLikelihood &&
      props.location.state.dnaBasedRisks &&
      props.location.state.bloodType
    ) {
      setResponseHealthBasedRisks(props.location.state.healthBasedRisks);
      setHealthBasedRisksObj(
        parseHealthRisks(props.location.state.healthBasedRisks)
      );
      setResponseLikelihood(props.location.state.infectionLikelihood);
      setLikelihoodObj(
        parseLikelihood(props.location.state.infectionLikelihood, t)
      );
      setResponseDnaBasedRisks(props.location.state.dnaBasedRisks);
      setDnaTotalRisk(parseDnaTotalRisk(props.location.state.dnaBasedRisks, t));
      setResponseBloodType(props.location.state.bloodType);
    } else {
      getSpareAssessments().then(resp => {
        if (resp) {
          setResponseHealthBasedRisks(resp.health_based_severity);
          setHealthBasedRisksObj(parseHealthRisks(resp.health_based_severity));
          setResponseLikelihood(resp.past_infection_likelihood);
          setLikelihoodObj(parseLikelihood(resp.past_infection_likelihood, t));
          setResponseDnaBasedRisks(resp.dna_based_severity);
          setDnaTotalRisk(parseDnaTotalRisk(resp.dna_based_severity, t));
          setResponseBloodType(resp.blood_type);
        }
      });
    }
  }, []);

  useEffect(() => {
    getReports().then(response => {
      if (response && Object.keys(response).length === 0) {
        saveReports({ report_code: 'spare', language: 'en' });
      }
    });
  }, [getReports, saveReports]);

  useEffect(() => {
    getProfile().then(resp => {
      if (resp && resp.id) {
        window.sessionStorage.setItem('profileId', resp.id);
      }
    });
  }, [getProfile]);

  const handleProcessingErrorSeen = () => {
    if (!processingErrorSeen) {
      partialUpdateUserData({
        user_metadata: { processingErrorSeen: true },
      }).then(() => setProcessingErrorSeen(true));
    }
  };

  const getStateToTransfer = () => {
    return {
      healthBasedRisks: responseHealthBasedRisks,
      infectionLikelihood: responseLikelihood,
      dnaBasedRisks: responseDnaBasedRisks,
      bloodType: responseBloodType,
    };
  };

  const handleChatIconClick = event => {
    setPopperAnchor(popperAnchor ? null : event.currentTarget);
  };

  const handleNotificationClose = event => {
    setPopperAnchor(popperAnchor ? null : event.currentTarget);
    if (notificationSeen === false) {
      partialUpdateUserData({
        user_metadata: { dnaNotificationSeen: true },
      }).then(() => setNotificationSeen(true));
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      {responseHealthBasedRisks && responseLikelihood && (
        <DesktopMenu
          id={0}
          stateToTransferOnNavigation={getStateToTransfer()}
          hasDnaProcessed={isImputationCompleted(genotypeData)}
        />
      )}
      <Grid
        container={isDesktop}
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          width: `calc(100% - ${isDesktop ? 300 : 0}px)`,
        }}
      >
        {response && (
          <PageItemContainer>
            {isDesktop === false && (
              <Header
                squeeze
                primaryHeader
                showChatIcon={true}
                onChatIconClick={handleChatIconClick}
                hasUnreadMessages={notificationSeen === false}
                hasShareAction
                mainMenuItems={t('common.menu.mainItems', {
                  returnObjects: true,
                })}
                extraMenuItems={mapRoutesToMenuItems(response.user_metadata)}
              />
            )}
            {errorSpareAssessments && (
              <CustomDialog
                open={errorSpareAssessments}
                onCloseButton={() => {
                  window.location = '/';
                }}
                style={{ marginLeft: isDesktop ? '300px' : '0' }}
              >
                <ErrorMessageTile
                  level="error"
                  title={t('common.errorMessages.general.title')}
                  message={t('common.errorMessages.general.message')}
                  actionText={t('common.errorMessages.general.reloadAction')}
                  onButtonClick={() => {
                    window.location = '/';
                  }}
                ></ErrorMessageTile>
              </CustomDialog>
            )}

            {genotypeData &&
              userGroups &&
              userCanSeeDnaContent(userGroups) &&
              isImputationInError(genotypeData) && (
                <CustomDialog
                  open={processingErrorSeen === false}
                  onCloseButton={() => {
                    handleProcessingErrorSeen();
                  }}
                  style={{ marginLeft: isDesktop ? '300px' : '0' }}
                >
                  <ErrorMessageTile
                    level="error"
                    title={'ERROR'}
                    message={t(
                      'common.errorMessages.genotypeImputationError:message'
                    )}
                    actionText={'OK'}
                    onButtonClick={() => {
                      handleProcessingErrorSeen();
                    }}
                  ></ErrorMessageTile>
                </CustomDialog>
              )}
            {genotypeData &&
              userGroups &&
              userCanSeeDnaContent(userGroups) &&
              isGenotypeInvalid(genotypeData) && (
                <CustomDialog
                  open={true}
                  style={{ marginLeft: isDesktop ? '300px' : '0' }}
                >
                  <ErrorMessageTile
                    level="error"
                    title={'ERROR'}
                    message={t(
                      'common.errorMessages.genotypeProcessingError:message'
                    )}
                    actionText={'OK'}
                    onButtonClick={() => {
                      props.history.push({
                        pathname: ROUTE_ONBOARDING_DNA,
                        state: { returningVisit: true },
                      });
                    }}
                  ></ErrorMessageTile>
                </CustomDialog>
              )}
            {responseHealthBasedRisks != null && (
              <>
                <AssessmentSectionTitle
                  isDesktop={isDesktop}
                  showChatIcon={isDesktop}
                  onChatIconClick={handleChatIconClick}
                  title={t('reporting.myAssessment.riskAssessment')}
                  hasUnreadMessages={notificationSeen === false}
                />
                <Box>
                  {healthBasedRisksObj && (
                    <RiskAssessmentCard
                      percentage={getHealthRiskScorePercentage(
                        getHealthRiskScore(responseHealthBasedRisks)
                      )}
                      sectionTitle={t('reporting.myAssessment.healthBasedRisk')}
                      description={t(
                        'reporting.myAssessment.percentageDescription'
                      )}
                      sectionSubtitle={healthBasedRisksObj.text}
                      textColor={healthBasedRisksObj.textColor}
                      image={healthBasedRisksObj.image}
                    />
                  )}

                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    style={{
                      paddingRight: '20px',
                    }}
                  >
                    <Button
                      endIcon={<NavigateNextIcon />}
                      variant="text"
                      style={{
                        paddingLeft: '20px',
                      }}
                      onClick={() => {
                        trackEvent(
                          'Reporting',
                          'Learn more about Health-Based risk'
                        );
                        props.history.push({
                          pathname: ROUTE_ASSESSMENT_HEALTH_RISKS,
                          state: getStateToTransfer(),
                        });
                      }}
                    >
                      {t('reporting.myAssessment.learnMore')}
                    </Button>
                  </Box>
                </Box>
                <Box
                  style={{
                    borderBottom: '1px Solid #efefef',
                    marginBottom: '20px',
                  }}
                ></Box>
                <AssessmentSectionTitle
                  isDesktop={isDesktop}
                  title={t('reporting.myAssessment.dnaRiskAssessment')}
                />
                {/* DNA Risk Assessment Card Start */}
                <Box
                  style={{
                    borderBottom: '1px Solid #efefef',
                  }}
                >
                  <RiskAssessmentCard
                    sectionTitle={t('reporting.myAssessment.dnaBasedRisk')}
                    description={
                      isImputationInProgress(genotypeData)
                        ? t(
                            'common.errorMessages.genotypeStillProcessing:message'
                          )
                        : isDnaUploaded(genotypeData) === false
                        ? userCanSeeDnaContent(userGroups)
                          ? t('reporting.common.needsAttentionParagraph')
                          : t(
                              'reporting.myAssessment.unknownDnaBasedRiskExplanation'
                            )
                        : t('reporting.myAssessment.dnaBasedRiskExplanation')
                    }
                    sectionSubtitle={
                      isImputationInProgress(genotypeData)
                        ? t('reporting.myAssessment.processing')
                        : isDnaUploaded(genotypeData) === false
                        ? userCanSeeDnaContent(userGroups)
                          ? t('reporting.myAssessment.needsAttention')
                          : t('reporting.myAssessment.unknownExtended')
                        : dnaTotalRisk.text
                    }
                    showOnlyCta={
                      isImputationInProgress(genotypeData) !== true &&
                      isDnaUploaded(genotypeData) === false &&
                      userCanSeeDnaContent(userGroups) !== true
                    }
                    textColor={dnaTotalRisk.textColor}
                    image={
                      isImputationInProgress(genotypeData)
                        ? dnaBasedProcessing
                        : dnaTotalRisk.image
                    }
                  />
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    style={{
                      paddingRight: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    {isDnaUploaded(genotypeData) === false ? (
                      <Button
                        endIcon={<NavigateNextIcon />}
                        variant={
                          userCanSeeDnaContent(userGroups) ? 'outlined' : 'text'
                        }
                        style={{
                          marginLeft: '15px',
                          paddingRight: '10px',
                        }}
                        onClick={() =>
                          props.history.push({
                            pathname: userCanSeeDnaContent(userGroups)
                              ? ROUTE_ONBOARDING_DNA
                              : ROUTE_ASSESSMENT_DNA_RISKS,
                            state: { returningVisit: true },
                          })
                        }
                      >
                        {userCanSeeDnaContent(userGroups)
                          ? t('reporting.common.needsAttentionButton')
                          : t('reporting.myAssessment.learnMore')}
                      </Button>
                    ) : dnaTotalRisk.value > -1 ? (
                      <Button
                        endIcon={<NavigateNextIcon />}
                        variant="text"
                        style={{
                          paddingLeft: '20px',
                        }}
                        onClick={() =>
                          props.history.push({
                            pathname: ROUTE_ASSESSMENT_DNA_RISKS,
                            state: getStateToTransfer(),
                          })
                        }
                      >
                        {t('reporting.myAssessment.learnMore')}
                      </Button>
                    ) : (
                      <React.Fragment />
                    )}
                  </Box>
                </Box>
                {/* DNA Risk Assessment Card End */}
                {/* Likelihood Card Start */}
                {likelihoodObj && (
                  <LikelihoodReportCard
                    title={t('reporting.myAssessment.probabilityReportTitle')}
                    sectionTitle={t(
                      'reporting.myAssessment.probabilityYouHaveHad'
                    )}
                    isDesktop={isDesktop}
                    sectionSubtitle={likelihoodObj.levelText}
                    textColor={likelihoodObj.color}
                    illustration={likelihoodObj.illustration}
                    responseLikelihood={responseLikelihood}
                    responseHealthBasedRisks={responseHealthBasedRisks}
                  />
                )}
                {/* Likelihood Card End */}
                {/* Recomendations Card Start */}
                <RiskRecommendationCard
                  stateToTransfer={getStateToTransfer()}
                  isDesktop={isDesktop}
                />
                {/* Recomendations Card End */}
                {/* Risk Report Card Start */}
                <RiskReportCard
                  icon={<PDFReportIcon height={60} />}
                  title={t('reporting.myAssessment.riskReportTitle')}
                  downloadText={t('reporting.myAssessment.downloadPDFText')}
                  generatingText={t('reporting.myAssessment.generatingPDFText')}
                  buttonText={t('reporting.myAssessment.download')}
                  downloadUrl={
                    responseReports && responseReports.download_url
                      ? responseReports.download_url
                      : null
                  }
                  isDesktop={isDesktop}
                />
                {/* Risk Report Card End */}
                {/* Enterprise Demo Banner Start */}
                <Box
                  style={{
                    marginBottom: isDesktop ? '0' : '55px',
                  }}
                >
                  <ScheduleEnterpriseDemoBanner />
                </Box>
                {/* Enterprise Demo Banner End */}
              </>
            )}
            <ReportsBottomNavigation
              selected={reportsBottomNavigationOptions.home}
              onSelected={val =>
                props.history.push({
                  pathname: val,
                  state: getStateToTransfer(),
                })
              }
            />
          </PageItemContainer>
        )}

        {openDialog === true && (
          <CustomDialog
            open={openDialog}
            fullScreen={!isDesktop}
            noBorder
            style={{ marginLeft: isDesktop ? '300px' : '0' }}
          >
            <Box
              className={classes.iconButton}
              onClick={() => setOpenDialog(false)}
            >
              <CloseIcon className={classes.closeIcon} />
            </Box>
            <Box className={classes.dialogBody}>
              <Box>
                <Typography className={classes.dialogText} paragraph>
                  <Trans i18nKey="reporting.myAssessment.dialogBodyText" />
                </Typography>
              </Box>
              <Box textAlign="center" paddingTop="28px" paddingBottom="28px">
                <Button
                  backgroundGradient={
                    'linear-gradient(to right, #194378, #30eaff)'
                  }
                  onClick={() => setOpenDialog(false)}
                >
                  {t('reporting.myAssessment.soundsGoodButton')}
                </Button>
              </Box>
            </Box>
          </CustomDialog>
        )}
        <NotificationPopper
          anchor={popperAnchor}
          close={handleNotificationClose}
          text={
            genotypeData &&
            genotypeData.imputed_genotype_status &&
            genotypeData.imputed_genotype_status === 'imputation-completed'
              ? t('common.successMessages.genotypeProcessing:message')
              : genotypeData &&
                ((genotypeData.genotype_status &&
                  genotypeData.genotype_status === 'genotype-data-invalid') ||
                  (genotypeData.imputed_genotype_status &&
                    genotypeData.imputed_genotype_status ===
                      'imputation-error'))
              ? t('common.errorMessages.genotypeProcessingError:message')
              : 'No messages.'
          }
          hasMessages={notificationSeen}
        />
      </Grid>
    </div>
  );
}
